import { ApplicationInsights } from '@microsoft/applicationinsights-web';

class AppInsightsService {
    constructor(initConfigProvider) {
        this.appInsights = null;

        if (Boolean(initConfigProvider.environment)) { // non-null environment name
            this.appInsights = new ApplicationInsights({
                config: {
                    connectionString: this.getConnectionString(initConfigProvider.environment),
                    enableAutoRouteTracking: true
                }
            });

            this.appInsights.developerMode = initConfigProvider.environment == "Development";

            this.appInsights.loadAppInsights();
            this.appInsights.addTelemetryInitializer((envelope) => {
                envelope.tags["ai.cloud.role"] = "COI Frontend";
            });
            this.appInsights.trackPageView();
        }
    }
    
    logEvent(name, properties) {
        if (Boolean(this.appInsights)) {
            this.appInsights.trackEvent({ name: name }, properties);
        }
    }
    
    logMetric(name, average, properties) {
        if (Boolean(this.appInsights)) {
            this.appInsights.trackMetric({ name: name, average: average }, properties);
        }
    }
        
    logError(exception, cause) {
        if (Boolean(this.appInsights)) {
            this.appInsights.trackException({ exception: exception,  properties: { cause: cause } });
        }
    }

    logTrace(message, properties) {
        if (Boolean(this.appInsights)) {
            this.appInsights.trackTrace({ message: message }, properties);
        }
    }

    getConnectionString(environmentName) {
        switch (environmentName) {
            case 'Production':
                return 'InstrumentationKey=9552cea6-57a2-45a4-89e6-1705b006b66b;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/';
            case 'Staging':
                return 'InstrumentationKey=64546a87-5722-4b19-a9f3-f58bc1ae4210;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/';
            case 'Test':
                return 'InstrumentationKey=ef1dba7e-9c1d-4fc7-9b5d-ed73aac80155;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/';
            case 'Development':
                return 'InstrumentationKey=2551b8cd-d0a0-4a82-a98c-3ff9764e9802;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/';
            default:
                return '';
        }
    }
}

AppInsightsService.$inject = ['initConfigProvider'];

export default AppInsightsService;


// WEBPACK FOOTER //
// ./app/services/app-insights.service.js